import {getRegionPathConfig} from "@/core/utils/helpers/regions/regionUrlHelper";

async function parseFeaturesParams(searchParams) {
    const allFeatures = {
        sliders: {
            age: _.get(searchParams, 'age', null),
            height: _.get(searchParams, 'height', null),
            weight: _.get(searchParams, 'weight', null),
        },
        cup_size: {
            from: _.get(searchParams, 'cup_size.0', null),
            to: _.get(searchParams, 'cup_size.1', null),
        },
        lists: {
            orientation: _.get(searchParams, 'orientation', null),
            breast_type: _.get(searchParams, 'breast_type', null),
            pubic_hair: _.get(searchParams, 'pubic_hair', null),
            ethnicity: _.get(searchParams, 'ethnicity', null),
            skin_color: _.get(searchParams, 'skin_color', null),
            breast_size: _.get(searchParams, 'breast_size', null),
            hair_color: _.get(searchParams, 'hair_color', null),
            eye_color: _.get(searchParams, 'eye_color', null),
            body_type: _.get(searchParams, 'body_type', null),
            nationality: _.get(searchParams, 'nationality', null),
        },
    };

    this.applyFeaturesFromUrlPath(allFeatures);

    if (_.get(searchParams, 'gender', null)) {
        allFeatures.gender = _.get(searchParams, 'gender', null);
    }

    _.each(_.keys(allFeatures), subFeaturesKey => {
        _.each(_.keys(allFeatures[subFeaturesKey]), key => {
            if (allFeatures[subFeaturesKey][key] == null) {
                delete allFeatures[subFeaturesKey][key];
            }
        });
    });

    if (!Object.keys(allFeatures.lists).length) {
        return this.store.commit('setFeatures', allFeatures);
    }
    _.each(allFeatures.lists, (value, key) => {
        if (typeof value === 'string') {
            allFeatures.lists[key] = [value];
        }
    });

    return this.store.commit('setFeatures', allFeatures);
}

async function generateFeaturesParams(path) {
    let sliders = this.features.sliders;
    let lists = this.features.lists;

    let features = {
        ...sliders,
        ...lists,
    };

    if (_.get(this.features, 'cup_size.from', false)) {
        features.cup_size = this.features.cup_size.from + ',' + this.features.cup_size.to;
    }

    if (_.get(this.features, 'gender', false)) {
        features.gender = _.get(this.features, 'gender', false);
    }

    const featuresFromURL = this.extractFeaturesFromURLPath(path);

    if (featuresFromURL) {
        _.forEach(featuresFromURL, (value, key) => {
            // the gender feature is not an array
            if (key === 'gender') {
                features[key] = (features[key] === value ? null : value);
            } else {
                features[key] = _.difference(features[key], value);
            }
        });
    }

    return features;
}

function applyFeaturesFromUrlPath(allFeatures) {
    const featuresFromUrl = this.extractFeaturesFromURLPath();

    Object.keys(allFeatures.sliders).forEach(key => {
        if (featuresFromUrl[key] && allFeatures.sliders[key] === null) {
            allFeatures.sliders[key] = featuresFromUrl[key];
        }
    });

    Object.keys(allFeatures.lists).forEach(key => {
        if (featuresFromUrl[key] && allFeatures.lists[key] === null) {
            allFeatures.lists[key] = featuresFromUrl[key];
        }
    });

    if (featuresFromUrl.gender) {
        allFeatures.gender = featuresFromUrl.gender;
    }
}

function extractFeaturesFromURLPath(path = window.location.pathname || '') {
    const regionPath = getRegionPathConfig();

    let defaultSearchUrl = _.get(this, 'settings.defaultSearchUrl', '');

    if (regionPath) {
        path = path.replace(`/${regionPath}/`, '/');
        defaultSearchUrl = defaultSearchUrl.replace(`/${regionPath}/`, '/');
    }

    let foundFeatures = [];

    /**
     * Match the most specific filter URL exactly (full path, then drop the trailing
     * city segment and retry), mirroring extractServicesFromURLPath. A substring match
     * here would pick the default category (e.g. `escort`), which is contained in every
     * UK path, and never strip the category's own features from the query.
     */
    if (!defaultSearchUrl || _.trim(path, '/') !== _.trim(defaultSearchUrl, '/')) {
        let splited = _.compact(path.split('/'));
        const paths = constants.seo_filter;

        while (splited.length) {
            const url = splited.join('/');
            const match = paths.find((filter) => _.trim(filter.url, '/') === url);

            if (match) {
                foundFeatures = _.get(match, 'features', []);
                break;
            }

            splited.pop();
        }
    }

    const sliders = foundFeatures.sliders || null;
    const lists = foundFeatures.lists || null;

    let object = {
        ...sliders,
        ...lists,
    };

    if (typeof foundFeatures.gender !== 'undefined') {
        object.gender = foundFeatures.gender;
    }

    return object;
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        parseFeaturesParams,
        generateFeaturesParams,
        applyFeaturesFromUrlPath,
        extractFeaturesFromURLPath,
    },
    computed: {
        ...mapState([
            'features',
            'settings',
        ])
    },
}
